import React, { useEffect, useState, useRef } from 'react';
import defaultClasses from './column.module.css';
import { useStyle } from '../../classify';
import resourceUrl from '../../makeUrl';
import { useMediaQuery } from '../../useMediaQuery';

const { matchMedia } = globalThis;

const Column = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const [bgImageStyle, setBgImageStyle] = useState(null);
    const columnElement = useRef(null);
    const {
        appearance,
        backgroundAttachment,
        backgroundColor,
        backgroundPosition,
        backgroundRepeat = 'repeat',
        backgroundSize,
        border,
        borderColor,
        borderRadius,
        borderWidth,
        children,
        cssClasses = [],
        desktopImage,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        mediaQueries,
        minHeight,
        mobileImage,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        textAlign,
        verticalAlignment,
        width
    } = props;

    const { styles: mediaQueryStyles } = useMediaQuery({ mediaQueries });

    let image = desktopImage;
    if (mobileImage && matchMedia && matchMedia('(max-width: 768px)').matches) {
        image = mobileImage;
    }

    const flexDirection = 'column';
    const display = 'flex';

    let alignSelf;

    switch (appearance) {
        case 'align-top':
            alignSelf = 'flex-start';
            break;
        case 'align-center':
            alignSelf = 'center';
            break;
        case 'align-bottom':
            alignSelf = 'flex-end';
            break;
        case 'full-height':
        default:
            alignSelf = 'stretch';
            break;
    }

    let justifyContent;

    switch (verticalAlignment) {
        case 'top':
        default:
            justifyContent = 'flex-start';
            break;
        case 'middle':
            justifyContent = 'center';
            break;
        case 'bottom':
            justifyContent = 'flex-end';
            break;
    }

    const dynamicStyles = {
        alignSelf,
        backgroundColor,
        border,
        borderColor,
        borderRadius,
        borderWidth,
        display,
        flexDirection,
        justifyContent,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        minHeight,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        textAlign,
        verticalAlignment,
        width
    };

    if (image) {
        dynamicStyles.backgroundImage = bgImageStyle;
        dynamicStyles.backgroundSize = backgroundSize;
        dynamicStyles.backgroundPosition = backgroundPosition;
        dynamicStyles.backgroundAttachment = backgroundAttachment;
        dynamicStyles.backgroundRepeat = backgroundRepeat;
    }

    // Determine the containers width and optimize the image
    useEffect(() => {
        if (image && columnElement.current) {
            if (backgroundSize === 'cover') {
                setBgImageStyle(
                    `url(${resourceUrl(image, {
                        type: 'image-wysiwyg',
                        width: columnElement.current.offsetWidth,
                        height: columnElement.current.offsetHeight,
                        quality: 85,
                        crop: false,
                        fit: 'cover'
                    })})`
                );
            } else {
                setBgImageStyle(
                    `url(${resourceUrl(image, {
                        type: 'image-wysiwyg',
                        quality: 85
                    })})`
                );
            }
        }
    }, [backgroundSize, image, setBgImageStyle]);

    return (
        <div
            style={{ ...dynamicStyles, ...mediaQueryStyles }}
            ref={columnElement}
            className={[classes.root, ...cssClasses].join(' ')}
        >
            {children}
        </div>
    );
};

export default Column;
